<!-- 由 suu 创建于 2020-03-26 星期四 -->
<template>
  <div cl>
    <div
      @click="onClick"
      :id="box"
      ref="div"
      :class="{ 'ys-float-btn user-btn': true, 'slot-btn': !imgSrc && !text }"
      :style="{
        left: left + 'px',
        top: top + 'px',
        'z-index': zIndex,
        width: !imgSrc && !text ? 'auto' : itemWidth + 'px',
        height: !imgSrc && !text ? 'auto' : itemHeight + 'px'
      }"
    >
      <slot></slot>
      <img
        v-if="imgSrc"
        :class="[text ? 'img-multiple' : 'img-only']"
        :src="imgSrc"
        alt
      />
      <div class="text" v-if="text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GymSuspensionBtn',

  mixins: [],

  components: {},

  props: {
    itemWidth: {
      default: 60
    }, // 总宽度
    itemHeight: {
      default: 50
    }, // 总高度
    coefficientHeight: {
      default: 0.6
    }, // 高度偏移量占屏幕高度比
    text: {}, // 文字
    imgSrc: {}, // 图标
    routerUrl: {}, // 跳转路由
    gapWidth: {
      default: 5
    }, // 初始化left离边界偏移量位置
    initY: {}, // 初始化Y轴位置
    initLeft: {}, // 默认偏移在左边
    zIndex: {} // 层级
  },

  data() {
    return {
      box: 'box' + new Date().getTime() + Math.random(),
      top: 0,
      left: 0,
      clientWidth: 0,
      clientHeight: 0,
      timer: null,
      currentTop: 0
    }
  },

  computed: {},

  watch: {},

  created() {},

  // 注销监听
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScrollStart)
  },

  mounted() {
    this.init()
    window.addEventListener('scroll', this.handleScrollStart)
    this.$nextTick(() => {
      const div = document.getElementById(this.box)
      div.addEventListener('touchstart', (e) => {
        div.style.transition = 'none'
      })
      div.addEventListener('touchmove', (e) => {
        /* 阻止移动端屏幕默认滑动 */
        e.preventDefault()
        if (e.targetTouches.length === 1) {
          let touch = e.targetTouches[0]
          this.left =
            touch.clientX -
            (document.getElementById(this.box)
              ? document.getElementById(this.box).offsetWidth
              : this.itemWidth) /
              2
          this.top = touch.clientY - this.itemHeight / 2
        }
      })
      div.addEventListener('touchend', (e) => {
        div.style.transition = 'all 0.3s'
        if (this.left > this.clientWidth / 2) {
          this.left =
            this.clientWidth -
            (document.getElementById(this.box)
              ? document.getElementById(this.box).offsetWidth
              : this.itemWidth) -
            this.gapWidth
        } else {
          this.left = this.gapWidth
        }
        if (this.top < 20) {
          this.top = 20
        } else if (
          this.top >
          this.clientHeight -
            (document.getElementById(this.box)
              ? document.getElementById(this.box).offsetHeight
              : this.itemHeight) -
            50
        ) {
          this.top =
            this.clientHeight -
            (document.getElementById(this.box)
              ? document.getElementById(this.box).offsetHeight
              : this.itemHeight) -
            50
        }
      })
    })
  },

  destroyed() {},

  methods: {
    init() {
      // 获取屏幕高宽度
      this.clientWidth = document.documentElement.clientWidth
      this.clientHeight = document.documentElement.clientHeight
      // 初始化left top偏移量 默认按钮在屏幕靠右边 如果有initLeft则左边
      if (this.initLeft) {
        this.left = this.gapWidth
      } else {
        console.log('dd', document.getElementById(this.box).offsetWidth)
        this.left =
          this.clientWidth -
          (document.getElementById(this.box)
            ? document.getElementById(this.box).offsetWidth || this.itemWidth
            : this.itemWidth) -
          this.gapWidth
      }
      this.top = this.initY || this.clientHeight * this.coefficientHeight
    },
    onClick() {
      this.$emit('sClick')
      if (this.routerUrl) {
        this.$router.push(this.routerUrl)
      }
    },
    handleScrollStart() {
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.handleScrollEnd()
      }, 300)
      this.currentTop =
        document.documentElement.scrollTop || document.body.scrollTop
      if (this.left > this.clientWidth / 2) {
        this.left =
          this.clientWidth -
          (document.getElementById(this.box)
            ? document.getElementById(this.box).offsetWidth
            : this.itemWidth) /
            2
      } else {
        this.left =
          -(document.getElementById(this.box)
            ? document.getElementById(this.box).offsetWidth
            : this.itemWidth) / 2
      }
      // const ele = document.getElementById("box");
      // this.left = ~(ele.offsetWidth / 2);
    },
    handleScrollEnd() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop === this.currentTop) {
        if (this.left > this.clientWidth / 2) {
          this.left =
            this.clientWidth -
            (document.getElementById(this.box)
              ? document.getElementById(this.box).offsetWidth
              : this.itemWidth) -
            this.gapWidth
        } else {
          this.left = this.gapWidth
        }
        clearTimeout(this.timer)
      }
    }
  }
}
</script>

<style lang="scss">
@function vw($px) {
  @return ($px / 750) * 100vw;
}

.ys-float-btn {
  position: fixed;
  z-index: 98;
  width: vw(100);
  height: vw(100);
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 vw(2) vw(4) #ccc;
  background-color: #fff;
  transition: all 0.3s;

  .img-only {
    width: 100%;
    height: 100%;
  }

  .img-multiple {
    width: 50%;
    height: 50%;
  }

  .text {
    font-size: vw(20);
    color: #4a4a4a;
    margin-top: vw(4);
  }
}

.slot-btn {
  background-color: transparent;
  box-shadow: none;
  overflow: auto;
  border-radius: 0;
}
</style>
